import { Navigate } from "react-router-dom";

const Logedin = ({  children }: any) => {      

    if (JSON.parse(localStorage.getItem("user") as string) === "null") {
        return <Navigate to="/" />;
    }

    return children;
};

export default Logedin;